import React from 'react';
import PropTypes from 'prop-types';
import BackButton from './BackButton';
import NextButton from './NextButton';

const NextBackButton = (props) => {
    return(
        <div className="col-xs-12">
            <BackButton
                onBackButtonClick={props.onBackButtonClick} />
            <NextButton
                isButtonDisabled={props.isButtonDisabled}
                onNextButtonClick={props.onNextButtonClick} />
        </div>
    );
};

NextBackButton.propTypes = {
    isButtonDisabled: PropTypes.bool,
    onBackButtonClick: PropTypes.func,
    onNextButtonClick: PropTypes.func
};

export default NextBackButton;


// WEBPACK FOOTER //
// ./src/components/Buttons/NextBackButton.js